import ColumnName from './ColumnName';
import ColumnRef from './ColumnRef';
import TovBuilder from './TovBuilder';

class ForeignKey {
  constructor(
    readonly _localColumn: Nullable<ColumnName>, // note: will be null if join type is cross join
    readonly _foreignColumn: ColumnRef,
  ) {}

  localColumn() {
    return this._localColumn;
  }

  foreignColumn() {
    return this._foreignColumn;
  }

  equals(fk: ForeignKey) {
    if (!fk) {
      return false;
    }
    if (!this.foreignColumn().equals(fk.foreignColumn())) {
      return false;
    }
    if (!this.localColumn()) {
      return !fk.localColumn();
    }
    return this.localColumn()?.equals(fk.localColumn());
  }

  static build(fkFromServer: ForeignKey) {
    return new ForeignKey(
      fkFromServer._localColumn
        ? ColumnName.build(fkFromServer._localColumn)
        : null,
      new ColumnRef(
        // @ts-expect-error: Check types and fix
        TovBuilder.build(fkFromServer._foreignColumn._table),
        fkFromServer._foreignColumn._name,
      ),
    );
  }
}

export default ForeignKey;
